import { Button, Modal } from "antd";
import React from "react";
import { useHistory } from "react-router";
import Logo from "../../../Assets/Images/logo.png";
import "./ResumePlanModal.less";

export const ResumePlanModal = ({
  setShowAddNewLocationDrawer,
  showAddNewLocationDrawer,
}) => {
  // showAddNewLocationDrawer
// setShowAddNewLocationDrawer
  const history = useHistory();
  return (
    <Modal
      centered
      visible={showAddNewLocationDrawer}
      footer={null}
      width={450}
      wrapClassName="resumePlanModelPOP"
    >
      <div className="resumePlanModel">
        <div className="text-center">
          <img src={Logo} alt="" />
        </div>
        <h1 className="text-center">Welcome! We're here to help you get things rolling.</h1>
        <h5>You cannot add new location as your current subscription plan is canceled. <br />Please renew or resume the plan.</h5>
        <div className="text-center pt-4">
          <Button
            type="primary"
            shape="round"
            size="large"
            htmlType="submit"
            className="mr-2 mr-md-4"
            onClick={() => history.push(`/settings/subscriptions`)}
          >
            Resume Plan
          </Button>
          <Button
            shape="round"
            htmlType="button"
            size="large"
            onClick={() => setShowAddNewLocationDrawer(false)}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};
